<template>
    <router-view></router-view>
</template>
<script>
export default {
  name: 'organizations',
  components: {}
}
</script>


// WEBPACK FOOTER //
// src/views/t1/Admin/Organizations.vue